import "./shared/tools/smartLogger.js";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { createPinia } from "pinia";

import "./assets/tailwind.css";
import "./assets/animate.css";
import "./assets/sass/css/windzo.css";
import vClickOutside from "click-outside-vue3";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vueform from '@vueform/vueform';
import vueformConfig from './vueform.config';
import "vue-data-ui/style.css";
import Equal from 'equal-vue';
import Config from 'equal-vue/dist/theme/full';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { registerOfflineIcons } from "./shared/iconify/registerOfflineIcons";

import { VueUiRadar } from "vue-data-ui";
import { Vue3OrgChartPlugin } from 'vue3-org-chart';
import 'vue3-org-chart/dist/style.css';
import axios from "axios";
import { applyAxiosAuth } from "./api/axiosAuthSetup";



const app = createApp(App);
applyAxiosAuth(axios, router);
registerOfflineIcons();
app.use(router);
app.use(createPinia());
app.use(VueApexCharts);
app.use(PerfectScrollbar);
app.use(Equal, Config);
app.use(vClickOutside);
app.use(Vueform, vueformConfig);
app.component('EasyDataTable', Vue3EasyDataTable);

app.use(Vue3OrgChartPlugin);
app.component('VueDatePicker', VueDatePicker);

app.component("VueUiRadar", VueUiRadar);

const options = {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
}

app.use(Toast, options);
app.mount("#app");

